module.exports = __webpack_public_path__ + "img/TruckOff.536e16f6.png";